import React, { useState } from "react";
import { EyeIcon,EyeSlashIcon } from "@heroicons/react/24/outline";

const PasswordInputField = ({
  value,
  onChange,
  placeHolder,
  type,
  errorMessage,
  name,
  classes,
  inputClasses
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <div>
      <div className="w-full">
        <div className={`${classes}`}>
          <input
            id={name}
            name={name}
            type={showPassword ? "text" : "password"}
            value={value}
            placeholder={placeHolder}
            className={`${inputClasses}`}
            onChange={onChange}
          />
          {type === "password" && (
            <span
              onClick={handleTogglePassword}
              className="cursor-pointer absolute right-5 pr-3 top-1/2 transform -translate-y-1/2 w-6"
            >
              {showPassword ? <EyeSlashIcon className="w-6 h-6" /> : <EyeIcon className="w-6 h-6" />}
            </span>
          )}
        </div>
        {errorMessage && (
          <p className="text-red-500 text-xs leading-[160%] font-bold mb-4 -mt-4 block">
            {errorMessage}
          </p>
        )}
      </div>
    </div>
  );
};

export default PasswordInputField;
